// extracted by mini-css-extract-plugin
module.exports = {"key":"key_key__Q8vcf"};